import { INSURANCE_TYPES_ICONS_V2 } from 'constants/insurance';
import React from 'react';
import styles from './policiesList.scss';
import { prettifyNumber } from 'helpers';
import { IPolicy } from 'types';
import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';

interface IProps {
  policy: IPolicy;
}

const getAmounts = (cover) => {
  const rawAmount = cover.insuredAmount || cover.amount;

  if (!rawAmount) {
    return '';
  }

  const amount = ` - $${prettifyNumber(rawAmount)}`;

  if (cover.payoutFrequency) {
    return `${amount}/${cover.payoutFrequency.toLowerCase().replace('ly', '')}`;
  }

  return amount;
};

const LifeCoversList = ({ policy }: IProps) => {
  const { policyType, insured } = policy;
  const covers =
    policyType === INSURANCE_TYPES_NAMES.LIFE
      ? insured[0].additionalCovers
      : [policy];

  return covers.map((c) => (
    <div key={c.policyType} className={styles.cover}>
      <div className={styles.coverImg}>
        <img alt={c.policyType} src={INSURANCE_TYPES_ICONS_V2[c.policyType]} />
      </div>
      <span>
        <b>{c.policyType}</b>
        {getAmounts(c)}
      </span>
    </div>
  ));
};

export default LifeCoversList;
